import { AUTHENTICATING_SLACK_REQUEST, AUTHENTICATING_SLACK_SUCCEDDED, AUTHENTICATING_SLACK_FAILED,
    UPDATING_SLACK_REQUEST, UPDATING_SLACK_SUCCEDDED, UPDATING_SLACK_FAILED,
} from '../actionTypes.jsx';
import axios from 'axios';

import {activatingIntegrationSuccedded, deactivatingIntegrationSuccedded,
  integrationAuthExpired} from '../integrations';

const apiUrl = `${process.env.REACT_APP_API_URL}`;

const SLACK_BASE_URL = `${apiUrl}/api/2.0/integrations/slack`;
const SLACK_AUTHENTICATION_URL = `${SLACK_BASE_URL}/authenticate`;
const SLACK_UPDATE_URL = `${SLACK_BASE_URL}`;

export function authenticateAccount(code){
  return function (dispatch) {
    dispatch(authenticatingAccount());

    const data = {
      code: code
    }

    return axios({
      method: 'POST',
      url: SLACK_AUTHENTICATION_URL,
      headers: {'Content-Type':'application/x-www-form-urlencoded'},
      params: data
    })
    .then((response) => {
      dispatch(authenticatingAccountSuccedded(response.data));
      dispatch(activatingIntegrationSuccedded(response.data));
    })
    .catch(error =>
      dispatch(authenticatingAccountFailed(error.response.data))
    )
  }
}

function authenticatingAccount(){
  return {
    type: AUTHENTICATING_SLACK_REQUEST,
    payload: {}
  }
}

function authenticatingAccountSuccedded(json){
  return {
    type: AUTHENTICATING_SLACK_SUCCEDDED,
    payload: json
  }
}

function authenticatingAccountFailed(error){
  return {
    type: AUTHENTICATING_SLACK_FAILED,
    payload: error
  }
}

/**
* Update slack configuration
*/
export function updateConfiguration(configuration){
  return function (dispatch) {
    dispatch(updatingConfiguration());

    return axios({
      method: 'PUT',
      url: SLACK_UPDATE_URL,
      data: configuration
    })
    .then((response) => {
      dispatch(updatingConfigurationSuccedded(response.data));
      dispatch(activatingIntegrationSuccedded(response.data));
    })
    .catch(error => {
      dispatch(integrationAuthExpired(error.errors, "slack"));
      dispatch(updatingConfigurationFailed(error))
    })
  }
}

function updatingConfiguration(){
  return {
    type: UPDATING_SLACK_REQUEST,
    payload: {}
  }
}

function updatingConfigurationSuccedded(json){
  return {
    type: UPDATING_SLACK_SUCCEDDED,
    payload: json
  }
}

function updatingConfigurationFailed(error){
  return {
    type: UPDATING_SLACK_FAILED,
    payload: error
  }
}